import { cn, getInitials, getAvatarColor } from '../lib/utils';

interface AvatarProps {
  src?: string;
  alt?: string;
  name?: string;
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  online?: boolean;
  className?: string;
}

export default function Avatar({
  src,
  alt,
  name,
  size = 'md',
  online,
  className,
}: AvatarProps) {
  const sizes = {
    xs: 'h-6 w-6 text-xs',
    sm: 'h-8 w-8 text-sm',
    md: 'h-10 w-10 text-base',
    lg: 'h-12 w-12 text-lg',
    xl: 'h-16 w-16 text-2xl',
  };

  const indicatorSizes = {
    xs: 'h-1.5 w-1.5',
    sm: 'h-2 w-2',
    md: 'h-2.5 w-2.5',
    lg: 'h-3 w-3',
    xl: 'h-4 w-4',
  };

  const displayName = alt || name || '';
  const initials = name ? getInitials(name) : '';
  const colorClass = name ? getAvatarColor(name) : 'bg-ink-3';

  return (
    <div className={cn('relative inline-block', className)}>
      {src ? (
        <img
          src={src}
          alt={displayName}
          className={cn(
            'rounded-full object-cover ring-2 ring-surface',
            sizes[size]
          )}
        />
      ) : (
        <div
          className={cn(
            'flex items-center justify-center rounded-full font-semibold text-white ring-2 ring-surface',
            sizes[size],
            colorClass
          )}
        >
          {initials}
        </div>
      )}
      {online !== undefined && (
        <span
          className={cn(
            'absolute bottom-0 right-0 block rounded-full ring-2 ring-surface',
            indicatorSizes[size],
            online ? 'bg-signal' : 'bg-ink-3'
          )}
        />
      )}
    </div>
  );
}
